import type { Promotion } from "../alea-club-app/src/types/content";

export const promotions: Promotion[] = [
  {
    id: "primera-visita",
    serviceId: "limpieza-facial-profunda",
    name: "Primera Visita ALÉA",
    image: "/images/promotions/primera-visita-portada-v1.jpg",
    imageFit: "full",
    headline: "Limpieza facial profunda en promoción",
    priceLabel: "$399",
    originalPriceLabel: "$550",
    validity: "Cupos limitados · Solo clientas nuevas",
    includes: [
      "Limpieza facial profunda de 60 min",
      "Diagnóstico de piel personalizado",
      "Mini rutina de regalo para llevar",
    ],
    conditions:
      "Válido únicamente para clientas de primera vez. Una promoción por persona. Sujeto a disponibilidad de agenda.",
  },
  {
    id: "botox-antifaz",
    serviceId: "botox",
    name: "Botox 3 áreas (antifaz)",
    image: "/images/services/botox.jpg",
    imageFit: "contain",
    secondaryImage: "/images/services/botox-portada-v1.jpg",
    headline: "3 áreas en una aplicación",
    priceLabel: "$3,440",
    originalPriceLabel: "$4,300",
    validity: "Sujeto a disponibilidad de agenda",
    includes: ["Aplicación de Botox en 3 áreas (antifaz)"],
    conditions: "Requiere cita previa. Las áreas y la aplicación se definen mediante valoración profesional.",
  },
  {
    id: "relleno-labios-1ml",
    serviceId: "relleno-de-labios",
    name: "Relleno de labios 1 ml",
    image: "/images/services/relleno-de-labios.jpg",
    imageFit: "contain",
    secondaryImage: "/images/services/relleno-de-labios-portada-v1.jpg",
    headline: "Perfilado y volumen labial · 3 sesiones",
    priceLabel: "$3,680",
    originalPriceLabel: "$4,600",
    validity: "Sujeto a disponibilidad de agenda",
    includes: ["Relleno de labios 1 ml", "3 sesiones"],
    conditions: "Requiere cita previa. Las áreas y la aplicación se definen mediante valoración profesional.",
  },
  {
    id: "russian-lips-1ml",
    serviceId: "russian-lips",
    name: "Russian Lips 1 ml",
    image: "/images/services/russian-lips.jpg",
    imageFit: "contain",
    secondaryImage: "/images/services/russian-lips-portada-v1.jpg",
    headline: "Definición y volumen con técnica Russian Lips",
    priceLabel: "$3,760",
    originalPriceLabel: "$4,700",
    validity: "Sujeto a disponibilidad de agenda",
    includes: ["Aplicación de 1 ml con técnica Russian Lips"],
    conditions: "Requiere cita previa. Las áreas y la aplicación se definen mediante valoración profesional.",
  },
  {
    id: "carboxiterapia-8-sesiones",
    serviceId: "carboxiterapia",
    name: "Carboxiterapia · 2 áreas / 8 sesiones",
    image: "/images/services/carboxiterapia.jpg",
    imageFit: "contain",
    secondaryImage: "/images/services/carboxiterapia-portada-v1.jpg",
    headline: "Un paquete de 8 sesiones para 2 áreas",
    priceLabel: "$3,999",
    originalPriceLabel: "$5,000",
    validity: "Sujeto a disponibilidad de agenda",
    includes: ["8 sesiones de carboxiterapia", "Tratamiento en 2 áreas"],
    conditions: "Requiere cita previa. Las áreas y la aplicación se definen mediante valoración profesional.",
  },
];
